// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

type HandlerType = ApiHandler<{
    includeEvent: boolean | undefined;
    eventType: string;
    clickText?: string;
    destination?: string;
}>;

const XngGaGeneralEvent: HandlerType = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const currentPage = getCurrentPage(state).type;
    const currentBillTo = getCurrentBillToState(state).value;

    const { includeEvent, eventType, clickText, destination } = props.parameter;

    if (includeEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: eventType,
            page_path: currentPage,
            click_text: clickText,
            destination,
            brand_code: currentBillTo?.properties?.brand,
            exclusive: currentBillTo?.properties?.exclusive,
            group_descr: currentBillTo?.properties?.groupDescription,
        };

        dataLayer.push(googleAnalyticsData);
    }
};

export const chain = [XngGaGeneralEvent];

const xngGaGeneralEventEvent = createHandlerChainRunner(chain, "XngGaGeneralEvent");
export default xngGaGeneralEventEvent;
